var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcoSize(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ico-size",
    transform: "translate(-1681 -859)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "ico-fidelity",
    width: 24,
    height: 24,
    transform: "translate(1681 859)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ico-size-2",
    "data-name": "ico-size",
    d: "M18.556,20.778h2.222V15.222h-10v-10H5.222V7.444H7.444V9.667H5.222v2.222H8.556v2.222H5.222v2.222H7.444v2.222H5.222v2.222H7.444V18.556H9.667v2.222h2.222V17.444h2.222v3.333h2.222V18.556h2.222ZM13,13h8.889A1.111,1.111,0,0,1,23,14.111v7.778A1.111,1.111,0,0,1,21.889,23H4.111A1.111,1.111,0,0,1,3,21.889V4.111A1.111,1.111,0,0,1,4.111,3h7.778A1.111,1.111,0,0,1,13,4.111Z",
    transform: "translate(1680 858)",
    fill: "#7498c9"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoSize);
export default __webpack_public_path__ + "static/media/ico-size.ff566621b096cc07f7ddf118d3677bf9.svg";
export { ForwardRef as ReactComponent };